import FlashcardsLayout from '../../../components/studentPage/flashcards/FlashcardsLayout'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/student/flashcards/')({
  component: FlashcardsLayout,
})
